import React from "react";
import { ReviewContainer } from "../../../containers";

const Review = (props) => {
  return <ReviewContainer {...props} />;
};

export default Review;
